import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RedirectCommand, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private authService = inject(AuthenticationService);
  private router = inject(Router);

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | RedirectCommand {
    if (this.authService.isAuthenticatedSync()) {
      const path = this.router.parseUrl(state.url).root.children['primary']?.segments;
      const isPasswordPage = path?.length === 1 && path[0].path === 'reset-password';
      if (this.authService.user()?.passwordChangeRequired && !isPasswordPage) {
        return new RedirectCommand(this.router.parseUrl('/reset-password'));
      }
      return true;
    }
    const loginUrl = this.router.parseUrl('/auth');
    return new RedirectCommand(loginUrl);
  }
}
